import React from 'react';
import './select-input.css';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
export interface IOptions {
    value: any;
    text: string;
    optionalParam?: string;
    disabled?: boolean;
}

interface ISelectInputProps {
    name: string;
    label?: string;
    options: any[];
    onChange?: (event: React.ChangeEvent<any>) => void;
    hasDefaultOption?: boolean;
    defaultOption?: string;
    value?: string | number;
    error?: string;
    required?: boolean;
    labelClassName?: string;
    fieldClassName?: string;
    disabled?: boolean;
    inlineStyle?: object;
    customLabel?: boolean;
}

const SelectInput = ({
    name,
    label,
    options,
    onChange,
    hasDefaultOption,
    defaultOption,
    value,
    error,
    required,
    labelClassName,
    fieldClassName,
    disabled,
    inlineStyle,
    customLabel,
}: ISelectInputProps) => {
    const intl = useIntl();
    let wrapperClass = 'form-group';
    if (error && error.length > 0) {
        wrapperClass += ' has-error';
    }

    return (
        <div className={wrapperClass}>
            {label &&
                (!customLabel ? (
                    <label
                        className={
                            labelClassName
                                ? 'control-label ' + labelClassName
                                : 'control-label col-sm-4'
                        }
                        htmlFor={name}
                    >
                        {intl.formatMessage({
                            id: label.replace(/ /g, '_'),
                            defaultMessage: label,
                        })}
                        :
                    </label>
                ) : (
                    <label
                        className={
                            labelClassName
                                ? 'control-label ' + labelClassName
                                : 'control-label col-sm-4'
                        }
                        htmlFor={name}
                        style={{ textTransform: 'none' }}
                    >
                        {intl.formatMessage({
                            id: label.replace(/ /g, '_'),
                            defaultMessage: label,
                        })}{' '}
                        {required && (
                            <span
                                className="fas fa-asterisk required-red"
                                style={{ fontSize: '8px' }}
                            />
                        )}
                    </label>
                ))}
            <div
                className={
                    fieldClassName
                        ? 'field ' + fieldClassName
                        : 'field col-sm-8'
                }
            >
                <div className={required ? 'input-group' : ''}>
                    {/* Note, value is set here rather than on the option - docs: https://facebook.github.io/react/docs/forms.html */}
                    <select
                        name={name}
                        value={
                            (value =
                                value || value === 0 ? value : defaultOption)
                        }
                        onChange={onChange}
                        className="form-control"
                        disabled={disabled}
                        style={inlineStyle}
                    >
                        {hasDefaultOption && defaultOption && (
                            <option value="">
                                {defaultOption === 'Select'
                                    ? intl.formatMessage({
                                          id: defaultOption,
                                          defaultMessage: defaultOption,
                                      }) + '...'
                                    : intl.formatMessage({
                                          id: defaultOption.replace(/ /g, '_'),
                                          defaultMessage: defaultOption,
                                      })}
                            </option>
                        )}
                        {options.map((option, i) => {
                            if (option)
                                return (
                                    <option
                                        key={
                                            // new 'no receiver' option caused NaN error, so added this workaround for now
                                            isNaN(option.value)
                                                ? 'NaN' + i.toString()
                                                : option.value + i.toString()
                                        }
                                        value={option.value.toString()}
                                        disabled={
                                            option.disabled ? true : false
                                        }
                                    >
                                        {option.text}
                                    </option>
                                );
                        })}
                    </select>
                    {required && !customLabel && (
                        <span className="input-group-addon">*</span>
                    )}
                </div>
                {/* {error && <div className="alert alert-danger">{error}</div>} */}
            </div>
        </div>
    );
};

export default SelectInput;
